import { render, staticRenderFns } from "./water-enter.vue?vue&type=template&id=3df1e4aa&scoped=true"
import script from "./water-enter.vue?vue&type=script&lang=js"
export * from "./water-enter.vue?vue&type=script&lang=js"
import style0 from "./water-enter.vue?vue&type=style&index=0&id=3df1e4aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df1e4aa",
  null
  
)

export default component.exports